import React from 'react';

const DashboardEmptyState: React.FC = () => (
  <div className="au-dashboard-empty-state">
    <div className="au-dashboard-empty-state-illustration" aria-hidden="true">
      <div className="au-dashboard-empty-state-cloud" />
      <div className="au-dashboard-empty-state-cloud au-dashboard-empty-state-cloud-secondary" />
      <div className="au-dashboard-empty-state-monitor">
        <div className="au-dashboard-empty-state-monitor-header" />
        <div className="au-dashboard-empty-state-chart">
          <div className="au-dashboard-empty-state-bars">
            <span className="au-dashboard-empty-state-bar au-dashboard-empty-state-bar-sm" />
            <span className="au-dashboard-empty-state-bar au-dashboard-empty-state-bar-md" />
            <span className="au-dashboard-empty-state-bar au-dashboard-empty-state-bar-sm" />
            <span className="au-dashboard-empty-state-bar au-dashboard-empty-state-bar-lg" />
            <span className="au-dashboard-empty-state-bar au-dashboard-empty-state-bar-xl" />
          </div>
          <svg
            className="au-dashboard-empty-state-line"
            viewBox="0 0 120 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 40L34 18L55 35L80 12L106 6"
              stroke="#FFB100"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="7" cy="40" r="3" fill="#FFB100" />
            <circle cx="34" cy="18" r="3" fill="#FFB100" />
            <circle cx="55" cy="35" r="3" fill="#FFB100" />
            <circle cx="80" cy="12" r="3" fill="#FFB100" />
            <circle cx="106" cy="6" r="3" fill="#FFB100" />
          </svg>
        </div>
        <div className="au-dashboard-empty-state-stand" />
      </div>
      <div className="au-dashboard-empty-state-plus">+</div>
    </div>

    <h2 className="au-dashboard-empty-state-title">Your dashboard is waiting</h2>
    <p className="au-dashboard-empty-state-description">
      Data will appear after your first user is added.
    </p>
  </div>
);

export default DashboardEmptyState;
